/* eslint-disable react/jsx-props-no-spreading */
import { useCallback, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import FieldDropDownV2 from 'src/components/FormComponents/FieldDropdownV2'
import Form from 'src/components/FormComponents/Form'
import Submit from 'src/components/FormComponents/Submit'
import { defaultFulfillmentCenterTypeFilters } from 'src/features/fulfillmentCenterFilters'
import { selectFulfillmentCenters } from 'src/features/selector'
import { actions as appActions } from 'src/features/state'
import { selectSalesChannelsByFC, selectSelectedSalesChannels } from '../../StockAddressingInBatchSelectors'
import { actions } from '../../StockAddressingInBatchState'
import * as S from './SelectFCAndChannelForm.styles'
import { toast } from 'react-toastify'

enum FormValueNames {
  FulfillmentCenterId = 'fulfillmentCenterId',
  SalesChannelId = 'salesChannelId'
}

const newOption = (id: number | string, name: string) => ({ value: id, label: name })

const defaultOption = newOption('', 'Selecione...')

export default () => {
  const dispatch = useDispatch()
  const {
    control, handleSubmit, register, resetField, watch,
  } = useForm()
  const selectedFCId = watch(FormValueNames.FulfillmentCenterId)
  const selectedChannelId = watch(FormValueNames.SalesChannelId)

  const fcs = useSelector(selectFulfillmentCenters)
  const salesChannels = useSelector(selectSalesChannelsByFC)

  const selectedSalesChannels = useSelector(selectSelectedSalesChannels)

  const preparedFCs = [
    defaultOption,
    ...fcs.map((fc) => newOption(fc.id, fc.name)),
  ]

  const preparedSalesChannels = [
    defaultOption,
    ...salesChannels.map((sc) => newOption(sc.id, sc.name)),
  ]

  const hasSalesChannels = salesChannels && salesChannels.length

  const resetForm = useCallback(() => {
    resetField(FormValueNames.FulfillmentCenterId)
    resetField(FormValueNames.SalesChannelId)
    dispatch(actions.setSalesChannelsByFC([]))
  }, [dispatch, resetField])

  useEffect(() => {
    dispatch(appActions.getAvailableFulfillmentCenters(defaultFulfillmentCenterTypeFilters))
  }, [dispatch])

  useEffect(() => {
    if (!selectedFCId) {
      resetForm()
      return
    }

    dispatch(actions.getSalesChannelsByFC(selectedFCId))
  }, [dispatch, selectedFCId, resetForm])

  const isFcNotValid = useCallback((FCId: number) => {
    if (selectedSalesChannels.length === 0) {
      return false
    }
    return selectedSalesChannels
      .every(({ fulfillmentCenter }) => fulfillmentCenter.id !== FCId)
  }, [selectedSalesChannels])

  const onSubmit = () => {
    if (!selectedFCId || !selectedChannelId) {
      return
    }

    if (isFcNotValid(Number(selectedFCId))) {
      toast.error('Não é permitido endereçar para FCs diferentes')
      return
    }

    if (selectedSalesChannels.some(({ salesChannel }) => salesChannel.id === Number(selectedChannelId))) {
      toast.error('Canal já adicionado')
      return
    }

    const [selectedFC] = fcs
      .filter((fc) => fc.id === Number(selectedFCId))

    const [selectedChannel] = salesChannels
      .filter((sc) => sc.id === Number(selectedChannelId))

    dispatch(actions.addSelectedSalesChannel({
      fulfillmentCenter: selectedFC,
      salesChannel: selectedChannel,
    }))
  }

  return (
    <S.Form as={Form} onSubmit={handleSubmit(onSubmit)}>
      <S.Field
        as={FieldDropDownV2}
        labelText='Fulfillment Center'
        defaultValue={defaultOption.value}
        control={control}
        options={preparedFCs}
        {...register(FormValueNames.FulfillmentCenterId)}
      />
      <S.Field
        as={FieldDropDownV2}
        labelText='Loja (Canal)'
        defaultValue={defaultOption.value}
        control={control}
        options={preparedSalesChannels}
        disabled={!hasSalesChannels}
        {...register(FormValueNames.SalesChannelId)}
      />
      <S.Submit as={Submit} text='Adicionar' disabled={!selectedChannelId} />
    </S.Form>
  )
}
